<template>
    <v-layout>
        <v-flex xs12 v-if="loading">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex xs12 v-if="!loading">
            <v-card>
                <v-card-title class="headline primary white--text">
                    {{ 'Points'|translate }}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <span style="width:300px;"><v-text-field class="mr-4" clearable v-model="search" type="text"
                                                             :label="'Keyword filter'|translate"></v-text-field></span>
                    <v-btn class="accent" @click="editedItem=null;dialog=true" :disabled="!$can('update', 'Points')">
                        <v-icon small class="mr-2">fa-plus</v-icon>
                        {{ 'Add Record'|translate }}
                    </v-btn>
                    <v-btn class="accent" @click="exportPoints">
                        <v-icon small class="mr-2">fa-download</v-icon>
                        {{ 'Download'|translate }}
                    </v-btn>
                    <v-btn class="accent ml-2" @click="diffModeDialog=true" :loading="loading">
                        <v-icon small class="mr-2">fa-not-equal</v-icon>
                        View Diff
                    </v-btn>
                    <input @change="readFile" type="file" style="display:none" ref="fileInput" accept=".csv, text/csv">
                    <v-btn class="accent ml-2" @click="uploadDialog = true" :disabled="!$can('update', 'Points')">
                        <v-icon small class="mr-2">fa-file-upload</v-icon>
                        {{ 'Upload Point List'|translate }}
                    </v-btn>
                    <v-btn class="accent ml-2" @click="multiUploadDialog = true" :disabled="!$can('update', 'Points')">
                        <v-icon small class="mr-2">fa-upload</v-icon>
                        {{ 'Upload Data'|translate }}
                    </v-btn>
                    <maintenance-upload-dialog
                        v-model="uploadDialog"
                        v-if="uploadDialog"
                        endpoint="/point-list-upload/"
                        v-on:doreload="refresh()"
                        diff-options
                        title="Point List upload"
                        upload-title="Upload Point List CSV"
                    >
                    </maintenance-upload-dialog>
                    <maintenance-upload-dialog
                        v-model="multiUploadDialog"
                        v-if="multiUploadDialog"
                        endpoint="/multiple-series-upload/"
                        cleanup
                        v-on:doreload="multiUploadDialog=false;"
                        title="Data Upload"
                        upload-title="Upload CSV/Excel Data"
                    >
                    </maintenance-upload-dialog>
                    <maintenance-upload-dialog
                        v-model="pointImportDialog"
                        v-if="pointImportDialog&&editedItem"
                        endpoint="/series-upload/"
                        cleanup
                        :sensor-id="editedItem.sensor_id"
                        v-on:doreload="pointImportDialog=false;"
                        :title="'Upload data for '+editedItem.facility_name+' - '+editedItem.equipment_name+' - '+editedItem.sensor_name"
                        :upload-title="'Upload CSV/Excel data for '+editedItem.facility_name+' - '+editedItem.equipment_name+' - '+editedItem.sensor_name"
                    >
                    </maintenance-upload-dialog>
                    <point-record-dialog v-model="dialog" :item="editedItem"
                                         v-on:reloadpoints="refresh"></point-record-dialog>
                    <v-dialog v-model="diffModeDialog" persistent max-width="600">
                        <v-card v-if="diffModeDialog">
                            <v-card-title class="headline primary white--text">
                                {{ 'View Diff'|translate }}
                            </v-card-title>
                            <v-card-text>
                                <v-select
                                    :items="diffModes"
                                    label="Diff mode"
                                    v-model="diffMode"
                                ></v-select>
                            </v-card-text>
                            <v-spacer></v-spacer>
                            <v-btn @click="diffModeDialog =false; onPickFile()" >{{ 'Select File'|translate }}</v-btn>
                            <v-btn @click="diffModeDialog =false">{{ 'Close'|translate }}</v-btn>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="diffDialog" persistent fullscreen>
                        <v-card v-if="diffDialog">
                            <v-card-text>
                                <v-tabs fixed-tabs v-model="tab" class="mt-4">
                                    <v-tab :key="1">
                                        <v-chip color="green" text-color="white">
                                            <v-avatar class="green darken-4">{{ diffNew.length }}</v-avatar>
                                            {{ 'New'|translate }}
                                        </v-chip>
                                    </v-tab>
                                    <v-tab :key="2">
                                        <v-chip color="orange" text-color="white">
                                            <v-avatar class="orange darken-4">{{ diffEdited.length }}</v-avatar>
                                            {{ 'Edited'|translate }}
                                        </v-chip>
                                    </v-tab>
                                    <v-tab-item :key="1">
                                        <v-data-table
                                            :headers="diffHeaders"
                                            disable-initial-sort
                                            :items="diffNew"
                                            :rows-per-page-items="[10,25,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                                        >
                                            <template v-slot:items="props">
                                                <td class="text-xs-left">{{ props.item.sensor_id }}</td>
                                                <td class="text-xs-left">{{ props.item.id }}</td>
                                                <td class="text-xs-left">{{ props.item.site }}</td>
                                                <td class="text-xs-left">{{ props.item.equip }}</td>
                                                <td class="text-xs-left">{{ props.item.equip_type }}</td>
                                                <td class="text-xs-left">{{ props.item.meta }}</td>
                                                <td class="text-xs-left">{{ props.item.upstream_sensor_name }}</td>
                                                <td class="text-xs-left">{{ props.item.sensor_name }}</td>
                                                <td class="text-xs-left">{{ props.item.unit }}</td>
                                                <td class="text-xs-left">{{ props.item.floor }}</td>
                                                <td class="text-xs-left">{{ props.item.equip_meta }}</td>
                                                <td class="text-xs-left">{{ props.item.sensor_desc }}</td>
                                                <td class="text-xs-left">{{ props.item.connector_id }}</td>
                                                <td class="text-xs-left">{{ props.item.calculations_statement }}</td>
                                            </template>
                                        </v-data-table>
                                    </v-tab-item>
                                    <v-tab-item :key="2">
                                        <v-data-table
                                            :headers="diffHeaders"
                                            disable-initial-sort
                                            :items="diffEdited"
                                            :rows-per-page-items="[10,25,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                                        >
                                            <template v-slot:items="props">
                                                <td class="text-xs-left">{{ props.item.sensor_id }}</td>
                                                <td class="text-xs-left">{{ props.item.id }}</td>
                                                <td class="text-xs-left" v-html="highlight(props.item.site)"></td>
                                                <td class="text-xs-left" v-html="highlight(props.item.equip)"></td>
                                                <td class="text-xs-left" v-html="highlight(props.item.equip_type)"></td>
                                                <td class="text-xs-left" v-html="highlight(props.item.meta)"></td>
                                                <td class="text-xs-left" v-html="highlight(props.item.upstream_sensor_name)"></td>
                                                <td class="text-xs-left"
                                                    v-html="highlight(props.item.sensor_name)"></td>
                                                <td class="text-xs-left" v-html="highlight(props.item.unit)"></td>
                                                <td class="text-xs-left" v-html="highlight(props.item.floor)"></td>
                                                <td class="text-xs-left" v-html="highlight(props.item.equip_meta)"></td>
                                                <td class="text-xs-left"
                                                    v-html="highlight(props.item.sensor_desc)"></td>
                                                <td class="text-xs-left"
                                                    v-html="highlight(props.item.connector_id)"></td>
                                                <td class="text-xs-left"
                                                    v-html="highlight(props.item.calculations_statement)"></td>
                                            </template>
                                        </v-data-table>
                                    </v-tab-item>
                                </v-tabs>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn @click="diffDialog =false">{{ 'Close'|translate }}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>

                </v-card-actions>

                <v-card-text>
                    <v-data-table
                        :headers="headers"
                        :items="points"
                        :search="search2"
                        class="elevation-1"
                        :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
                        :items-per-page="25"
                    >
                        <template v-slot:items="props">
                            <td>{{ props.item.sensor_id }}</td>
                            <td class="text-xs-left">{{ props.item.sensor_name }}</td>
                            <td class="text-xs-left">
                                {{ props.item.sensor_name_abbr }}
                            </td>
                            <td class="text-xs-left">{{ props.item.unit }}</td>
                            <td class="text-xs-left">{{ props.item.haystack_id }}</td>
                            <td class="text-xs-left">{{ props.item.facility_name }}</td>
                            <td class="text-xs-left">{{ props.item.weight }}</td>
                            <td class="text-xs-left">{{ props.item.equipment_name }}</td>
                            <td class="text-xs-left">{{ props.item.meta }}</td>
                            <td class="justify-center layout px-0">
                                <v-icon
                                    small
                                    class="mr-2"
                                    v-if="$can('update', 'Points')"
                                    @click="$can('update', 'Points') && editItem(props.item)"
                                >
                                    fa-edit
                                </v-icon>
                                <v-icon
                                    small
                                    class="mr-2"
                                    v-if="$can('update', 'Points')"
                                    @click="$can('update', 'Points') && importToItem(props.item)"
                                >
                                    fa-upload
                                </v-icon>
                                <v-icon
                                    small
                                    v-if="$can('update', 'Points')"
                                    @click="$can('update', 'Points') && deleteItem(props.item)"
                                >
                                    fa-trash
                                </v-icon>
                            </td>
                        </template>
                        <template v-slot:no-data>
                            <v-btn color="primary" @click="initialize">{{ 'Reset'|translate }}</v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getPoint, deletePoint, getEquipment} from '../helper'
import PointRecordDialog from '../components/points/PointRecordDialog'
import MaintenanceUploadDialog from "../components/maintenance/MaintenanceUploadDialog";
import {exportCSV} from '../tocsv'
import _ from "lodash";

export default {
    name: 'Points',
    components: {PointRecordDialog, MaintenanceUploadDialog},
    data() {
        return {
            dialog: false,
            tab: 0,
            uploadDialog: false,
            multiUploadDialog: false,
            pointImportDialog: false,
            search: '',
            search2: '',
            timeout: null,
            loading: true,
            equipments: [],
            diffDialog: false,
            diffMode: "upstream_id and connector_id",
            diffModes: ["upstream_id and connector_id","sensor_id"],
            diffModeDialog:false,
            diffNew: [],
            diffEdited: [],
            headers: [
                {
                    text: this.$options.filters.translate('Sensor ID'),
                    align: 'left',
                    sortable: true,
                    value: 'sensor_id'
                },
                {text: this.$options.filters.translate('Sensor Name'), value: 'sensor_name'},
                {text: this.$options.filters.translate('Sensor Name Abbr'), value: 'sensor_name_abbr'},
                {text: this.$options.filters.translate('Unit'), value: 'unit', sortable: false},
                {text: this.$options.filters.translate('Upstream ID'), value: 'haystack_id', sortable: false},
                {text: this.$options.filters.translate('Facility Name'), value: 'facility_name'},
                {text: this.$options.filters.translate('Weight'), value: 'weight'},
                {text: this.$options.filters.translate('Equipment Name'), value: 'equipment_name'},
                {text: this.$options.filters.translate('Meta'), value: 'meta', sortable: false},
                {text: this.$options.filters.translate('Actions'), sortable: false},
            ],
            diffHeaders: [
                {
                    "text": "sensor_id",
                    "value": "sensor_id"
                },{
                    "text": "upstream_id",
                    "value": "upstream_id"
                },
                {
                    "text": "site",
                    "value": "site"
                },
                {
                    "text": "equip",
                    "value": "equip"
                },
                {
                    "text": "equip_type",
                    "value": "equip_type"
                },
                {
                    "text": "meta",
                    "value": "meta"
                },
                {
                    "text": "upstream_sensor_name",
                    "value": "upstream_sensor_name"
                },
                {
                    "text": "sensor_name",
                    "value": "sensor_name"
                },
                {
                    "text": "unit",
                    "value": "unit"
                },
                {
                    "text": "floor",
                    "value": "floor"
                },
                {
                    "text": "equip_meta",
                    "value": "equip_meta"
                },
                {
                    "text": "sensor_desc",
                    "value": "sensor_desc"
                },
                {
                    "text": "connector_id",
                    "value": "connector_id"
                },
                {
                    "text": "calculations_statement",
                    "value": "calculations_statement"
                }
            ],
            points: [],
            editedIndex: -1,
            editedItem: {},
        }
    },
    watch: {
        search() {
            this.debounce(this.syncSearches, 500);
        }
    },
    mounted() {
        this.initialize()
    },
    methods: {
        highlight(text) {
            if (text && text.includes(" => ")) {
                return '<span style="color:darkorange;">' + text + '</span>'
            }
            return text
        },
        syncSearches() {
            this.search2 = this.search
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        async initialize() {
            await this.refresh()
            let search = _.get(this.$route.query,'search', null)
            if (search){
                this.search=search
            }
        },

        editItem(item) {
            this.editedIndex = this.points.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },

        importToItem(item) {
            this.editedItem = Object.assign({}, item)
            this.pointImportDialog = true
        },

        async deleteItem(item) {
            const index = this.points.indexOf(item)
            if (confirm(this.$options.filters.translate('Are you sure you want to delete this item?'))) {
                this.points.splice(index, 1)
                await deletePoint({
                    'sensor_id': item.sensor_id
                })
                this.refresh()
            }
        },
        exportPoints() {
            let cleanedItems = JSON.parse(JSON.stringify(this.points))
            exportCSV(cleanedItems.map(item => this.formatItem(item)))
        },

        async refresh() {
            this.loading = true
            let df = await getPoint({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
            })
            this.points = df['result']
            let edf = await getEquipment({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name
            })
            this.equipments = edf['result']
            this.dialog = false
            this.pointImportDialog = false
            this.uploadDialog = false
            this.multiUploadDialog = false
            this.loading = false
        },
        onPickFile() {
            this.$refs.fileInput.click()
        },
        formatItem(item) {
            let equipment = this.equipments.filter(x => x.equipment_id === item.equipment_id)[0]
            return {
                sensor_id: item.sensor_id ? item.sensor_id : "",
                upstream_id: item.haystack_id ? item.haystack_id : "",
                site: item.facility_name ? item.facility_name : "",
                equip: item.equipment_name ? item.equipment_name : "",
                equip_type: equipment.equipment_type ? equipment.equipment_type : "",
                equip_tags: equipment.equipment_tags ? JSON.stringify(equipment.equipment_tags) : "[]",
                meta: item.meta ? JSON.stringify(item.meta) : "{}",
                upstream_sensor_name: item.sensor_name_abbr ? item.sensor_name_abbr : item.sensor_name,
                sensor_name: item.sensor_name ? item.sensor_name : "",
                unit: item.unit ? item.unit : "",
                floor: equipment.floor ? equipment.floor : "",
                equip_meta: equipment.meta ? JSON.stringify(equipment.meta) : "{}",
                sensor_desc: item.sensor_desc ? item.sensor_desc : "",
                connector_id: item.connector_id ? item.connector_id : "",
                calculations_statement: item.calculations_statement ? item.calculations_statement : "",
            }
        },
        async readFile(e) {
            let me = this
            let file = e.target.files[0]
            let arr = []
            await this.$papa.parse(file, {
                download: true,
                worker: true,
                header: true,
                step: function (results) {
                    delete results.data[""]
                    arr.push(results.data)
                },
                complete: function () {
                    arr.pop()
                    let currentItems = JSON.parse(JSON.stringify(me.points)).map(item => me.formatItem(item))
                    let newItems = []
                    let editedItems = []
                    let verifiedKeys = [
                        "site",
                        "equip",
                        "equip_type",
                        "meta",
                        "upstream_sensor_name",
                        "sensor_name",
                        "unit",
                        "floor",
                        "equip_meta",
                        "sensor_desc",
                        "calculations_statement",
                    ]
                    for (let item of arr) {
                        let found=[]
                        if (me.diffMode==="sensor_id"){
                            found = currentItems.filter(x => parseInt(x.sensor_id) === parseInt(item.sensor_id))
                        } else {
                            found = currentItems.filter(x => x.upstream_id === item.upstream_id && x.connector_id === item.connector_id)
                        }
                        if (found.length > 0) {
                            let existingItem = JSON.parse(JSON.stringify(found[0]))
                            let changed = false
                            for (let key of verifiedKeys) {
                                if (item[key] !== existingItem[key]) {
                                    existingItem[key] = existingItem[key] + " => " + item[key]
                                    changed = true
                                }
                            }
                            if (changed) {
                                editedItems.push(existingItem)
                            }
                        } else {
                            newItems.push(item)
                        }
                    }
                    me.diffNew = newItems
                    me.diffEdited = editedItems
                    me.diffDialog = true
                }
            })
        },
    }
}
</script>

<style scoped>

</style>
